import { h } from 'preact';
import Store from 'store/store';
import * as BaseComp from 'components/bolt/hub/hub.js';
import { isVideosPage } from 'utils/bolt';
import { getDynamicData } from 'utils/bolt/dynamicData';
import { accessNested } from 'utils/utils';


const toKebabCase = str => str[0] === '-' ? str : str.replace(/[a-z][A-Z]/g, m => `${m[0]}-${m[1].toLowerCase()}`);

const encodedCharacters = ['~', '|', '\n'];
const decodeRegex = new RegExp(`~([${encodedCharacters.map((_, i) => i).join('')}])`, 'g');
const decode = str => str.replace(decodeRegex, (m, i) => encodedCharacters[i]);
export default class Hub extends BaseComp.default {

	async componentDidMount() {
		super.componentDidMount?.();
		const activePage = Store.get().activePage;

		switch (activePage) {
			case 'landing':
				await this.loadCustomData(await getDynamicData('landing'));
				break;
		}
	}

	get getPageContent() {
		return this.props.store?.appData?.pages?.[this.props.id] || {};
	}

	transformButtons(buttons) {
		return buttons ? buttons.map(b => {
			if (b.link && b.link.split('#')[1] === 'tickets') {
				let newLink = b.link.split('#').shift();
				b.link = newLink += '-showtimes';
			}
			if (b.link && b.link.split('#')[1] === 'homeEnt') {
				let newLink = b.link.split('#').shift();
				b.link = newLink += '-homeEnt';
			}
			this.transformOverlays(b.link, b);

			b.btnCopy = b.label;
			return b;
		}) : [];
	}

	transformOverlays(link, object) {
		if (!link || typeof link !== 'string') {
			console.warn('Invalid link:', link, object?.title || object?.label);
			return object;
		}
		if (link.startsWith('text-overlay:')) {
			let textOverlayParts = link.substring('text-overlay:'.length).split('|');
			let textOverlayInfo = decode(textOverlayParts[0] || '');
			let textOverlayImage = decode(textOverlayParts[1] || '');
			object.textOverlay = {
				content: {
					keyInfo: textOverlayInfo,
					img: textOverlayImage,
				}
			};
		} else if (link.startsWith('video-overlay:')) {
			let videoOverlayId = link.substring('video-overlay:'.length);
			const youtubeRegex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|e|watch)\S*?v=|[^\/\n\s]+\/\S*?\/|user\/[^\n\/]+\/|[^\n\/]+\/[^\n\/]+\/[^\n\/]+\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
			const match = videoOverlayId.match(youtubeRegex);

			if (match && match[1]) {
				videoOverlayId = match[1]; // Extracted YouTube ID
			}
			object.videoOverlay = {
				video: {
					name: '',
					youtubeId: videoOverlayId,
					thumbSrc: `https://i.ytimg.com/vi/${videoOverlayId}/mqdefault.jpg`,
					thumbAria: '',
				}
			};
		} else {
			object.path = link?.split('#')?.[0];
		}
		if (link.endsWith('#homeEnt')) {
			//first cut out the homeent
			const noHomeent = link.slice(0, -8);
			object.path = `${noHomeent}-homeEnt`;
			object.link = `${noHomeent}-homeEnt`;
		}
		return object;
	}

	async loadCustomData(dynamicData) {
		if (!dynamicData) {
			return;
		}
		const hero = dynamicData.heroCarousel || dynamicData.hero;

		this.heroCarousel = {
			hasGradient: true,
			content: hero?.map?.(slide => {
				if (!slide) return;
				const carousel = {
					id: slide.id,
					title: slide.title,
					description: slide.description,
					path: slide?.link,
					tag: slide.tag,
					background: { desktop: slide.img, mobile: slide.mobileImg, alt: slide.alt },
					buttons: this.transformButtons(slide.buttons),
				};
				return this.transformOverlays(slide.path, carousel);
			}).filter(e => e)
		};

		this.carousels = dynamicData.carousels?.map?.(carousel => {
			if (!carousel?.content?.length) {
				return;
			}
			return {
				heading: carousel.name,
				anchor: toKebabCase(carousel.name),
				tag: carousel.tag,
				isCategory: carousel.isCategory,
				tiles: carousel.content.map(srcTile => {
					if (!srcTile) return;
					const tile = {
						title: srcTile.title,
						teaser: srcTile.description,
						asset: srcTile.asset,
						altText: srcTile.altText,
						tag: srcTile.tag,
						buttons: srcTile.buttons && this.transformButtons(srcTile.buttons),
					};
					return this.transformOverlays(srcTile.link, tile);
				}).filter(e => e)
			};
		}).filter(e => e);
		this.forceUpdate();

		Store.emit('UPDATE_HUB_ACTIVE_PERCENTAGE');

		const hash = location.hash.slice(1);
		if (hash) {
			this.props.goToHash?.(hash);
		}
	}

	triggerButtonClick(data) {
		const { link, title, button, sameWindow } = data;
		Store.emit('TOUT_CLICK', 'vertical', 'tout', `${title} - ${button}`);
		if (link.startsWith('http')) {
			let link = document.createElement('a');
			link.href = data.link;
			link.target = sameWindow ? '_self' : '_blank';
			link.style.display = 'none';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} else if (link.startsWith('@')) {
			return Store.emit('OPEN_RESERVED_VARIABLE_LINK', link);
		} else if (link.startsWith('tickets/?id=')) {
			const movieId = link.replace('tickets/?id=', '').trim();
			this.openShowtimesAndFilterForMovieId(movieId);
		} else if (isVideosPage(link)) {
			return Store.emit('OPEN_VIDEO_OVERLAY', link);
		} else if (link === 'boltShowtimes') {
			return Store.emit('SHOWTIMES_SHOW', true);
		} else if (link === 'boltHomeEnt') {
			return Store.emit('HOMEENT_SHOW', true);
		} else {
			const linkIsSection = accessNested(this.props, `appData.pages.${link}.section`, false);
			if (linkIsSection) {
				return Store.emit('CHANGE_ACTIVE_SECTION', link);
			} else {
				return Store.emit('CLOSE_AND_NAVIGATE', link);
			}
		}
	}
}
